import { Route } from "@angular/router";

export const MeetingsPaths = {
  Overview: "",
  Introduction: "kennismaking",
  Evaluation: "evaluatie",
  Farewell: "afscheid",
  Templates: "sjablonen",
  TemplateAdd: "sjabloon/toevoegen",
  TemplateEdit: (templateId: number | string) => `sjabloon/bewerken/${templateId}`,
  Add: "toevoegen",
  Edit: (meetingId: number | string) => `bewerken/${meetingId}`,
  MakeReport: (meetingId: number | string) => `bewerken/${meetingId}/verslag`,
};

export default [
  {
    path: MeetingsPaths.Overview,
    loadComponent: () =>
      import("./pages/meeting-list/meeting-list.component").then((c) => c.MeetingListComponent),
    data: {
      breadcrumb: "Gesprekken",
      title: "Gesprekken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Introduction,
    loadComponent: () =>
      import("./pages/meeting-list/meeting-list.component").then((c) => c.MeetingListComponent),
    data: {
      breadcrumb: "Kennismakingsgesprekken",
      title: "Kennismakingsgesprekken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Evaluation,
    loadComponent: () =>
      import("./pages/meeting-list/meeting-list.component").then((c) => c.MeetingListComponent),
    data: {
      breadcrumb: "Evaluatiegesprekken",
      title: "Evaluatiegesprekken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Farewell,
    loadComponent: () =>
      import("./pages/meeting-list/meeting-list.component").then((c) => c.MeetingListComponent),
    data: {
      breadcrumb: "Afscheidsgesprekken",
      title: "Afscheidsgesprekken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Templates,
    loadComponent: () =>
      import("./pages/meeting-template-list/meeting-template-list.component").then(
        (c) => c.MeetingTemplateListComponent
      ),
    data: {
      breadcrumb: "Sjablonen voor gesprekken",
      title: "Sjablonen voor gesprekken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.TemplateAdd,
    loadComponent: () =>
      import("./pages/meeting-edit/meeting-edit.component").then((c) => c.MeetingEditComponent),
    data: {
      breadcrumb: "Sjabloon voor gesprek toevoegen",
      title: "Sjabloon voor gesprek toevoegen",
      isTemplate: true,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.TemplateEdit(":id"),
    loadComponent: () =>
      import("./pages/meeting-edit/meeting-edit.component").then((c) => c.MeetingEditComponent),
    data: {
      breadcrumb: "Sjabloon voor gesprek bewerken",
      title: "Sjabloon voor gesprek bewerken",
      isTemplate: true,
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Add,
    loadComponent: () =>
      import("./pages/meeting-edit/meeting-edit.component").then((c) => c.MeetingEditComponent),
    data: {
      breadcrumb: "Gesprek toevoegen",
      title: "Gesprek toevoegen",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.Edit(":id"),
    loadComponent: () =>
      import("./pages/meeting-edit/meeting-edit.component").then((c) => c.MeetingEditComponent),
    data: {
      breadcrumb: "Gesprek bewerken",
      title: "Gesprek bewerken",
      subscriptionTypes: [1, 4],
    },
  },
  {
    path: MeetingsPaths.MakeReport(":id"),
    loadComponent: () =>
      import("./pages/meeting-report/meeting-report.component").then(
        (c) => c.MeetingReportComponent
      ),
    data: {
      breadcrumb: "Verslag opmaken",
      title: "Verslag opmaken",
      subscriptionTypes: [1, 4],
    },
  },
] satisfies Route[];
